import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'
import Login from '@/pages/Login.vue'
import MainLayout from '@/layouts/MainLayout.vue'
import DocumentLayout from '@/layouts/DocumentLayout.vue'
import UserManagement from '@/pages/UserManagement.vue'
import OssConfigManagement from '@/pages/OssConfigManagement.vue'
import LoginLogs from '@/pages/LoginLogs.vue'
import DocView from '@/pages/DocView.vue'
import DocEdit from '@/pages/DocEdit.vue'
import CollectionList from '@/pages/CollectionList.vue'
import ShareView from '@/pages/ShareView.vue'
import { authUtils } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/share/:token',
    name: 'ShareView',
    component: ShareView,
    meta: { requiresAuth: false }
  },
  // Admin后台管理系统
  {
    path: '/admin',
    component: MainLayout,
    redirect: '/admin/users',
    children: [
      {
        path: 'users',
        name: 'UserManagement',
        component: UserManagement
      },
      {
        path: 'oss-config',
        name: 'OssConfigManagement',
        component: OssConfigManagement
      },
      {
        path: 'login-logs',
        name: 'LoginLogs',
        component: LoginLogs
      },
      {
        path: 'collections',
        name: 'AdminCollectionList',
        component: CollectionList
      },
      {
        path: 'collections/:id',
        name: 'AdminCollectionDetail',
        component: DocumentLayout,
        children: [
          {
            path: '',
            name: 'AdminCollectionDetailView',
            component: DocView
          },
          {
            path: 'doc/create',
            name: 'AdminCollectionDocCreate',
            component: DocEdit
          },
          {
            path: 'doc/:docId/edit',
            name: 'AdminCollectionDocEdit',
            component: DocEdit
          },
          {
            path: 'doc/:docId',
            name: 'AdminCollectionDocView',
            component: DocView
          }
        ]
      }
    ]
  },
  // 文集列表页面（首页）
  {
    path: '/',
    name: 'CollectionList',
    component: CollectionList,
    meta: { requiresAuth: true }
  },
  // 文集详情页面
  {
    path: '/collections/:id',
    component: DocumentLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'CollectionDetail',
        component: DocView
      },
      {
        path: 'doc/create',
        name: 'CollectionDocCreate',
        component: DocEdit
      },
      {
        path: 'doc/:docId/edit',
        name: 'CollectionDocEdit',
        component: DocEdit
      },
      {
        path: 'doc/:docId',
        name: 'CollectionDocView',
        component: DocView
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = authUtils.isAuthenticated()
  const userRole = authUtils.getUserRole()
  
  // 1. 公开路由放行
  if (to.matched.some(record => record.meta && record.meta.requiresAuth === false)) {
    next()
    return
  }

  // 2. 未登录访问受保护页面，跳转到登录页
  if (!isAuthenticated) {
    if (to.path !== '/login') {
      next('/login')
      return
    }
    next()
    return
  }
  
  // 3. 已登录访问登录页，跳转到首页
  if (to.path === '/login') {
    next('/')
    return
  }

  // 4. 核心拦截：任何包含 /admin 的路由，非管理员一律打回文档列表首页 /
  if (to.path.indexOf('/admin') !== -1) {
    if (userRole !== 'admin') {
      Message.warning('无权限访问管理后台，已自动返回文档列表')
      next('/')
      return
    }
  }

  next()
})

export default router
